<template>
  <div
    class="application-addable"
    :class="{'application-addable--empty': !items || items.length === 0}"
  >
    <!-- Items -->
    <template v-for="(item, index) in (items || [])">
      <ApplicationSection
        class="application-addable__item mb-ts-2"
      >

        <template #title>
          <div class="application-addable__title">
            <slot
              name="title"
              :index="parseInt(index)"
              :total="(items || []).length"
            />
          </div>
        </template>

        <template #title-description>
          <slot
            name="title-description"
            :index="parseInt(index)"
          />
        </template>

        <slot
          :item="item"
          :index="parseInt(index)"
        />

        <!-- Remove items button -->
        <button
            v-if="isRemovable(index)"
            class="btn btn--green-light print-hide mt-4"
            @click="remove(index)"
          >
          <TrashIcon class="application-addable__remove-button-icon" />
          {{sprintf(translate('Poista %s'), textItem)}}
        </button>

      </ApplicationSection>

      <ApplicationDivider wrapperClasses="" />
    </template>


    <template v-if="interactive && max !== null && (items || []).length < max">
      <!-- Add button -->
      <div>
        <button
          class="btn btn--green-light print-hide"
          @click="add"
        >
          <PlusIcon class="application-addable__button-add-icon print-hide" />
          {{textAdd ? textAdd : sprintf(translate('Lisää %s'), textItem)}}
        </button>
      </div>
    </template>
  </div>
</template>

<script>
  import {sprintf} from 'sprintf-js';

  import utils from '../mixins/utils';
  import ApplicationSection from './ApplicationSection';
  import ApplicationDivider from './ApplicationDivider';
  import PlusIcon from '../icons/PlusIcon.vue';
  import TrashIcon from '../icons/TrashIcon.vue';

  export default {
    mixins: [
      utils.translate,
    ],
    components: {
    ApplicationSection,
    ApplicationDivider,
    PlusIcon,
    TrashIcon
},
    props: {
      itemInit: {
        type: Function,
        required: true,
      },
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: null,
      },
      textAdd: {
        type: String,
        default: null,
      },
      textItem: {
        type: String,
        required: true,
      },
      interactive: {
        type: Boolean,
        required: true,
      },
    },
    methods: {
      sprintf,
      add() {
        this.$emit('update', [
          ...(this.items || []),
          this.itemInit(),
        ]);
      },
      remove(index) {
        const copy = [...(this.items || [])];
        copy.splice(index, 1);
        this.$emit('update', copy);
      },
      isRemovable(index) {
        return this.interactive && index + 1 > this.min;
      },
    },
  }
</script>

<style lang="scss">
  @import "~styles/definitions";

  .application-addable {
  }

  .application-addable__title {
    font-family: $ff-inter;
    color: $black;
    display: flex;
    align-items: center;
    font-size: 1.5rem;
  }

  .application-addable__remove-title {
    margin-left: r(16);

    @include media-breakpoint-up(xl) {
      display: none;
    }
  }

  .application-addable__remove-sidebar {
    display: none;

    @include media-breakpoint-up(xl) {
      display: block;
    }
  }

  .application-addable__remove-button {
    @include reset-button(true);
    @include font-body-16;
    display: flex;
    align-items: center;
    color: $color-pink;

    &:focus {
      text-decoration: underline;
    }
  }

  .application-addable__remove-button-icon {
    margin: r(-20) 0;
  }

  .application-addable__item {
    & + & {
      margin-top: r(48);
    }
  }

  .application-addable__button-add {
    @include reset-button(true);
    @include font-h-22;
    display: flex;
    align-items: center;

    &:focus {
      text-decoration: underline;
    }

    .application-addable--empty & {
      margin-top: 0;
    }
  }

  .application-addable__button-add-icon {
    margin: r(-20) 0;
  }
</style>
